import React from "react";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  return (
    <div
      className="relative bg-slate-950 text-white bg-no-repeat bg-cover sm:bg-contain bg-center sm:bg-[center_top]"
      style={{
        backgroundImage: "url('/help2.png')",
        backgroundAttachment: "scroll",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40" />

      <section className="relative min-h-screen flex flex-col items-center justify-between px-4 py-12 sm:px-6 lg:px-8">
        <div className="relative z-10 pt-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">Oriri Africa Fund</h1>
            <p className="text-lg text-gray-100 mt-2 drop-shadow-md">Financial Inclusion for Africa's Future</p>
          </div>
        </div>

        {/* <div className="relative z-10 flex flex-col items-center">
          <div className="w-1 h-24 bg-gradient-to-b from-orange-400 to-blue-500" />
        </div> */}

        <div className="relative z-10 pb-8 flex flex-col items-center gap-4">
          <div className="flex flex-col items-center gap-3 text-slate-900">
            <div className="relative flex h-16 w-10 items-start justify-center rounded-full border border-slate-900/60 bg-slate-950/75 p-2 shadow-[0_0_30px_rgba(15,23,42,0.28)] backdrop-blur-sm">
              <div className="scroll-indicator-dot h-3 w-3 rounded-full bg-slate-200 shadow-[0_0_18px_rgba(15,23,42,0.5)]" />
            </div>
            <span className="scroll-indicator-text inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.45em] text-white sm:text-sm">
              <svg className="h-4 w-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10l4 4 4-4" />
              </svg>
              Scroll to explore
            </span>
          </div>
        </div>
      </section>

      <section className="relative bg-white py-24 text-slate-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="grid gap-12 border-b border-slate-200 pb-14 lg:grid-cols-[1.15fr_0.85fr]">
              <div className="space-y-8">
                <div>
                  <span className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">
                    Overview
                  </span>
                  <h2 className="mt-5 max-w-4xl text-4xl font-bold leading-tight text-slate-900 md:text-5xl">
                    A formal platform for inclusive finance, enterprise support, and regional economic participation.
                  </h2>
                  <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-600">
                    Oriri Africa Fund is a Rwanda-based initiative established in 2024 to expand access to
                    responsible finance for underserved entrepreneurs and strengthen economic participation
                    through disciplined support, local partnership, and long-term institutional commitment.
                  </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2">
                  <div className="border-l-2 border-slate-900 pl-5">
                    <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Mandate</p>
                    <p className="mt-3 text-base leading-7 text-slate-700">
                      To extend fair financial access and practical business support to communities that remain
                      underserved by conventional systems.
                    </p>
                  </div>
                  <div className="border-l-2 border-slate-300 pl-5">
                    <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Approach</p>
                    <p className="mt-3 text-base leading-7 text-slate-700">
                      Combining capital access, advisory support, and partnership-based delivery to build durable
                      enterprise outcomes.
                    </p>
                  </div>
                </div>
              </div>

              <div className="border border-slate-200 bg-slate-50 p-8 md:p-10">
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                  Institutional Snapshot
                </p>
                <div className="mt-8 space-y-6">
                  <div className="flex items-end justify-between border-b border-slate-200 pb-5">
                    <div>
                      <p className="text-sm font-medium uppercase tracking-[0.16em] text-slate-500">Founded</p>
                      <p className="mt-2 text-base text-slate-600">Year of establishment</p>
                    </div>
                    <p className="text-3xl font-bold text-slate-900">2024</p>
                  </div>
                  <div className="flex items-end justify-between border-b border-slate-200 pb-5">
                    <div>
                      <p className="text-sm font-medium uppercase tracking-[0.16em] text-slate-500">Reach</p>
                      <p className="mt-2 text-base text-slate-600">Entrepreneurs supported</p>
                    </div>
                    <p className="text-3xl font-bold text-slate-900">50+</p>
                  </div>
                  <div className="flex items-end justify-between">
                    <div>
                      <p className="text-sm font-medium uppercase tracking-[0.16em] text-slate-500">Primary Region</p>
                      <p className="mt-2 text-base text-slate-600">Core geographic focus</p>
                    </div>
                    <p className="text-3xl font-bold text-slate-900">Rwanda</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid gap-0 py-14 md:grid-cols-3">
              <div className="border border-slate-200 p-10 md:border-r-0">
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
                  <svg className="w-7 h-7 text-slate-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m6 2a8 8 0 11-16 0 8 8 0 0116 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-slate-900">Partnership-Led Delivery</h3>
                <p className="mt-4 leading-7 text-slate-600">
                  Working with local institutions and community stakeholders to extend financial access through
                  trusted, context-specific implementation.
                </p>
              </div>

              <div className="border border-slate-200 p-10 md:border-r-0">
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
                  <svg className="w-7 h-7 text-slate-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-slate-900">Structured Financial Support</h3>
                <p className="mt-4 leading-7 text-slate-600">
                  Providing financing and advisory support aligned to the operational realities, growth stage,
                  and objectives of each entrepreneur.
                </p>
              </div>

              <div className="border border-slate-200 p-10">
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
                  <svg className="w-7 h-7 text-slate-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-slate-900">Sustainable Enterprise Growth</h3>
                <p className="mt-4 leading-7 text-slate-600">
                  Promoting resilient business development through inclusive financial models designed to support
                  durable enterprise and community outcomes.
                </p>
              </div>
            </div>

            <div className="grid gap-10 border-t border-slate-200 pt-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
              <div>
                <span className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">
                  Governance Outlook
                </span>
                <h3 className="mt-5 text-3xl font-bold leading-tight text-slate-900">
                  Built to operate with accountability, local relevance, and long-term discipline.
                </h3>
              </div>

              <div className="space-y-6">
                <p className="text-lg leading-8 text-slate-600">
                  The Fund is designed to respond to structural barriers in financial inclusion with a measured,
                  partnership-based approach that prioritizes fairness, sustainability, and practical enterprise support.
                </p>
                <div className="flex flex-col gap-6 border-l-2 border-slate-200 pl-6 md:flex-row md:items-center md:justify-between md:border-l-0 md:border-t md:pl-0 md:pt-6">
                  <div>
                    <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Further Information</p>
                    <p className="mt-2 text-base text-slate-600">
                      Review our mission, institutional direction, and leadership profile.
                    </p>
                  </div>
                  <button
                    onClick={() => navigate('/about')}
                    className="inline-flex items-center gap-2 border border-slate-900 px-8 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-slate-900 transition-colors duration-200 hover:bg-slate-900 hover:text-white"
                  >
                    View About Us
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
